<template>
  <b-container fluid>
    <h3>Where Part is Used</h3>
    <b-row><center>
      Just a note, you need to be on the VPN, or on the AndyMark network to use this page
    </center></b-row>
    <b-row class="justify-content-md-center">
      <b-col class="my-2" cols=8>
        <b-form @submit="drawGraph">
          <b-form-row class="align-items-center mb-2">
            <b-col>
              <b-alert variant=warning show v-if=override>
                <center>
                  Don't forget to add something similar to this to the beginning of your query, otherwise you're going to get ALL the posts<br />
                  <tt>
                    match (:RootNode)-[:LATEST]-&gt;(post:TimeNode)<br />
                    match q=(post)&lt;-[:POSTED_AT]-&lt;YOUR QUERY&gt;<br />
                    return &lt;RETURN VALUES&gt;
                  </tt>
                </center>
              </b-alert>
            </b-col>
          </b-form-row>
          <b-form-row class="align-items-center mb-2">
            <b-col cols=3 v-if=override>
              Cypher Query
            </b-col>
            <b-col cols=3 v-else>
              <label>Num (exact search only):</label>
            </b-col>

            <b-col cols=5 v-if=override>
              <textarea class='form-control mb-2 ml-1 mr-2 mb-sm-0' v-model="itemNum" />
            </b-col>
            <b-col cols=5 v-else>
              <b-form-input v-model="itemNum" class='form-control mb-2 ml-1 mr-2 mb-sm-0' />
            </b-col>

            <b-col>
              <b-button variant='primary' type='submit' :disabled="!showOnWeb && !showOffWeb">Search</b-button>
            </b-col>

            <b-col cols=2 v-if=itAccess>
              <i class="fas fa-fw fa-user-lock"></i>
              <label>I know what I'm doing (IT ONLY)</label>
            </b-col>
            <b-col v-if=itAccess>
              <b-form-checkbox v-model=override />
            </b-col>
          </b-form-row>
          <b-alert show v-if='Number(layers) > 5' variant=warning>
            The layer count is greater than 5. There's a good chance you're going to get a looot of results here.
          </b-alert>
          <b-form-row class="align-items-center mb-2">
            <b-col>
              Show me...
            </b-col>
            <b-col>
              <b-form-radio-group v-model='option' :options='["Parents", "Children"]' />
            </b-col>
            <b-col>
              How many layers deep?
            </b-col>
            <b-col>
              <b-form-input type=number min=1 v-model='layers'/>
            </b-col>
          </b-form-row>
          <b-form-row class='align-items-center mb-2'>
            <b-col cols=3>
            </b-col>
            <b-col cols=2>
              <b-form-checkbox v-model=showOnWeb>Updated To Web</b-form-checkbox>
              <b-form-checkbox v-model=showOffWeb>NOT Updated to Web</b-form-checkbox>
            </b-col>
            <b-col>
              <b-alert variant=danger :show="!showOnWeb && !showOffWeb">&lt;-- You're going to want to select at least one of those...</b-alert>
            </b-col>
          </b-form-row>
        </b-form>
      </b-col>
    </b-row>
    <b-row v-if="noExist" class="justify-content-md-center">
      This item doesn't seem to exist. Make sure you've typed in the exact part/product num, it may take a few minutes to show if you've just created it.
    </b-row>
    <b-row v-else-if="item != null && item.product_id != 0">
      <b-col>
        <b-row class="justify-content-md-center">
          Quantities shown are for the subassembly, not the total needed for the part/product
        </b-row>
        <b-row>
          <b-col>
            <strong>Product Num:</strong>
            <router-link target="_blank" :to="{name: 'Qty Calculations', query: {productNum: item.product_num}}">
              {{item.product_num}}
            </router-link>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <strong>Product Desc:</strong>
            {{item.product_desc}}
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row v-else-if="item != null">
      <b-col>
        <b-row>
          <b-col>
            <strong>Part Num:</strong>
            <router-link target="_blank" :to="{name: 'Qty Calculations', query: {partNum: item.part_num}}">
              {{item.part_num}}
            </router-link>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <strong>Part Desc:</strong>
            {{item.part_desc}}
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <div id="viz"></div>
  </b-container>
</template>

<script>
import axios from 'axios';
import Neovis from 'neovis.js'
import { mapActions, mapGetters } from 'vuex';
import { FingerprintSpinner } from 'epic-spinners';
const BASE_API = process.env.VUE_API_ROOT;

export default {
  components: {
    FingerprintSpinner,
  },
  data() {
    return {
      override: false,
      itemNum: null,
      option: 'Parents',
      showOnWeb: true,
      showOffWeb: true,
      layers: 2,
      item: null,
      noExist: false,
      config: {
        container_id: "viz",
        server_url: "bolt://neo4j.andymark.com:7687",
        server_user: "gone",
        server_password: "fishing",
        arrows: true,
        encrypted: window.location.protocol === "https:",
        trust: "TRUST_SYSTEM_CA_SIGNED_CERTIFICATES",
        labels: {
          "Ind": {
            "caption": "PartNum",
            "size": 0.5,
            "title_properties": [
              "PartDesc", "CustomPartType", "UomName", "CustomFieldFour", "AvailabilityText", "ProductPrice", "UpdatedToWeb"
            ],
          },
          "IndwBom": {
            "caption": "PartNum",
            "size": 0.5,
            "title_properties": [
              "PartDesc", "CustomPartType", "UomName", "CustomFieldFour", "AvailabilityText", "ProductPrice", "UpdatedToWeb"
            ],
          },
          "Bom": {
            "caption": "PartNum",
            "size": 1,
            "title_properties": [
              "PartDesc", "CustomPartType", "UomName", "CustomFieldFour", "AvailabilityText", "ProductPrice", "UpdatedToWeb"
            ],
          },
          "Kit": {
            "caption": "ProductNum",
            "size": 1,
            "title_properties": [
              "ProductDesc", "CustomPartType", "UomName", "CustomFieldFour", "AvailabilityText", "ProductPrice", "UpdatedToWeb"
            ],
          },
          [Neovis.NEOVIS_DEFAULT_CONFIG]: {
            "title_properties": [
              "PartDesc", "ProductDesc", "CustomPartType", "UomName", "CustomFieldFour", "AvailabilityText", "ProductPrice", "UpdatedToWeb"
            ],
            "caption": "PartNum"
          }
        },
        relationships: {
          "MAKES": {
            "thickness": "NeededToMake1",
            "caption": false
          }
        }
      }
    }
  },
  methods: {
    drawGraph(event) {
      if (event != null) event.preventDefault();

      this.noExist = false;
      axios({
        method: "POST",
        headers: { 'Content-Type': 'text/plain' },
        url: `${BASE_API}/ams3-fishioninfo/part-info/search`,
        data: {
          exactMatch: true,
          productNum: this.itemNum,
        },
      }).then(response => {
        var cypher = '';
        if (this.override) {
          cypher = this.itemNum;
        } else {
          var data = response.data;
          if (data.length == 0) {
            this.noExist = true;
            return;
          }

          var numSpec = data[0].product_num == "0"
            ? `{ PartNum: '${data[0].part_num}' }`
            : `{ ProductNum: '${data[0].product_num}' }`;
          var onWebSpec = this.showOnWeb ? this.showOffWeb ? '' : '{ UpdatedToWeb: true }' : '{ UpdatedToWeb: false }'
          var cypher = `
            MATCH (:RootNode)-[:LATEST]->(post:TimeNode)
            MATCH q = (post)<-[:POSTED_AT]-(c ${this.option == 'Parents' ? numSpec : onWebSpec})-[:MAKES*0..${Number(this.layers)}]->(p ${this.option == 'Children' ? numSpec : onWebSpec})
            RETURN c, relationships(q) AS r, p
          `;
        }

        this.config.initial_cypher = cypher;
        new Neovis(this.config).render();
      }).catch(error => {
        console.error(error);
      });
    }
  },
  computed: {
    ...mapGetters({
      isLoggedIn: 'isLoggedIn',
      canAccess: 'canAccess',
    }),
    itAccess() {
      return this.$store.getters.canAccess('it-staff')
    }
  },
}
</script>

<style scoped>
#viz {
  width: auto;
  height: 700px;
  border: 1px solid lightgray;
  font: 22pt arial;
}
</style>



// WEBPACK FOOTER //
// src/components/inventory/WherePartIsUsed.vue